// extracted by mini-css-extract-plugin
export default {"content":"DownloadOurApp_content__jR1sH","AppStoreAndGooglePlay":"DownloadOurApp_AppStoreAndGooglePlay__o3MAk","appStore":"DownloadOurApp_appStore__QkNu1"};